import { SpinningLoader } from "risa-oasis-ui_v2";

interface LoaderMessageProps {
  message: string;
}

/**
 * Full-area loading indicator used by RisaCustomTable while fetching.
 *
 * @param props - Loader message text
 * @returns Spinning loader with message
 */
export const LoaderMessage = (props: LoaderMessageProps) => {
  return (
    <div className="loader-message-layout h-full w-full bg-transparent">
      <SpinningLoader />
      <div className="message">{props.message}</div>
    </div>
  );
};
